export interface RoundInfoLaunchParams {
  gameId?: string;
  currencyId?: string;
  currencyDecimals?: number;
  symbolsPath?: string;
  replayData: unknown;
  operatorId?: string;
}

export function mountRoundInfoFrame(payload: RoundInfoLaunchParams, src = 'round-info.html'): void {
  document.body.innerHTML = '';

  const iframe = document.createElement('iframe');
  iframe.src = src;
  iframe.style.cssText =
    'position:fixed;inset:0;width:100%;height:100%;border:0;background:#1a1a2e;';
  iframe.addEventListener('load', () => {
    iframe.contentWindow?.postMessage({ type: 'roundInfoData', payload }, '*');
  });
  document.body.appendChild(iframe);
}
